/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.25",
    versionName: "0.6.0-nightly.2026.8.25",
    versionChannel: "nightly",
    buildDate: "2026-08-25T00:10:44.465Z",
    commitHash: "9a86ace3fd2bffa7ba83698e3fe9e0d6e4ea29df",
};
